import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Footer = () => {
  const { user } = useAuth();
  return (
    <footer
      className="border-t border-stone-900 bg-stone-950 mt-24"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="font-serif-display text-xl text-stone-200 tracking-tight">
            Cinder <span className="italic text-orange-400">&amp;</span> Sorrel
          </span>
          <span className="text-stone-600 text-sm">·</span>
          <span className="text-stone-500 text-xs uppercase tracking-[0.2em]">
            A cooking journal
          </span>
        </div>
        <nav className="flex items-center gap-6 text-sm text-stone-500">
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-stone-200 transition-colors"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-stone-200 transition-colors"
          >
            Terms
          </Link>
          {user && (
            <Link
              to="/account"
              data-testid="footer-account-link"
              className="hover:text-stone-200 transition-colors"
            >
              Account
            </Link>
          )}
          <span className="text-stone-700 text-xs font-mono-accent">
            © {new Date().getFullYear()}
          </span>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
